import { GridDetailsPanelColumn } from 'utils/components/GridDetailsPanel/GridDetailsPanelColumn';
import React from 'react';
import { GridDetailsPanelColumnDef } from 'utils/components/GridDetailsPanel/gridDetailsPanelColumnDef';
import { ResponsiveColumns } from '../ResponsiveColumns/ResponsiveColumns';
import { GridDetailColDef } from 'utils/components/GridDetailsPanel/GridDetailsPanel';

export interface GridDetailsPanelRowProps<
    TColumnId extends string,
    TEntity extends Partial<Record<TColumnId, unknown>>,
> {
    colDefs: GridDetailColDef<TEntity>[];
    entity: TEntity;
    panelColumnDefs: GridDetailsPanelColumnDef<TColumnId>[];
    twoColumns: boolean;
}

export function GridDetailsPanelRow<
    TColumnId extends string,
    TEntity extends Partial<Record<TColumnId, unknown>>,
>(props: GridDetailsPanelRowProps<TColumnId, TEntity>) {
    const { panelColumnDefs, colDefs, entity } = props;

    return (
        <ResponsiveColumns.Row>
            {panelColumnDefs.map((s, i) => (
                <GridDetailsPanelColumn
                    column={s}
                    key={'section-' + i}
                    colDefs={colDefs}
                    entity={entity}
                />
            ))}
        </ResponsiveColumns.Row>
    );
}
